import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../../../core/button.gjs';
import styles from './ghost.module.scss';

const METADATA = Metadata.define({
  description: `
    Agent ghost button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Agent Ghost Button',
  resources: {
    figma: 'https://www.figma.com/design/pAAy83e2t59aYqNR2Vhi2C/Sidekick-AI?node-id=354-7478&m=dev',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/v/0/p/56566c-buttons',
  },
});

export default class SpdsActionButtonAgentGhost extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-agent-ghost';
  variantStyles = styles;

  get variant() {
    return 'agent-ghost';
  }
}

export const ACTION_BUTTON_AGENT_GHOST_METADATA = SpdsActionButtonAgentGhost.metadata;
